import { render } from "./LeftDrawer.vue?vue&type=template&id=12d3b1e2"
import script from "./LeftDrawer.vue?vue&type=script&lang=js"
export * from "./LeftDrawer.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSplitter from 'quasar/src/components/splitter/QSplitter.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSplitter,QTabs,QTab,QTabPanels,QTabPanel});
